import { useSearchParams } from "react-router-dom";

export type QueryIdReturnProps = {
  id: string;
  set: (id: string) => void;
  reset: () => void;
  resetAll: () => void;
  getAll: () => string[] | null;
};

const resetAllExceptPagination = ["limit", "offset", "currentPage"];

const useQueryID = (name?: string, sameIds?: boolean): QueryIdReturnProps => {
  const [params, setParams] = useSearchParams();

  return {
    id: params.get(name || "id") || "",
    set: (id: string): void => {
      if (params.has(name || "id") && sameIds) {
        params.append(name || "id", id); // Allow multiple IDs to be added
      } else {
        params.set(name || "id", id); // Set the  ID
      }
      setParams(params);
    },
    reset: (): void => {
      params.delete(name || "id");
      setParams(params);
    },
    resetAll: (): void => {
      // Create a new URLSearchParams object
      const newParams = new URLSearchParams();

      // Preserve the keys in `resetAllExceptPagination`
      resetAllExceptPagination.forEach((key) => {
        const value = params.get(key);
        if (value) {
          newParams.set(key, value);
        }
      });

      // Update the URL with the new query parameters
      setParams(newParams);
    },
    getAll: (): string[] => {
      return params.getAll(name || "");
    },
  };
};

export default useQueryID;
